import { useLocation, useNavigate } from "react-router-dom";
import { Construction } from "lucide-react";
import { Button } from "@/components/ui/button";

const SECTION_LABELS: Record<string, string> = {
  "/accounts": "Контрагенти",
  "/holdings": "Холдинги",
  "/outlets": "Торгові точки",
  "/contacts": "Контакти",
  "/contracts": "Договори",
  "/meetings": "Зустрічі",
  "/tasks": "Завдання",
};

/**
 * Branded "page coming next phase" stub. Replaces the F0A diagnostic dump.
 * Every left-nav item that doesn't yet have a real page renders this.
 */
export function ShellPlaceholder() {
  const location = useLocation();
  const navigate = useNavigate();
  const label = SECTION_LABELS[location.pathname] ?? "Цей розділ";

  return (
    <div className="flex h-full items-center justify-center px-6 py-12">
      <div className="text-center max-w-md space-y-4">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
          <Construction className="w-7 h-7" />
        </div>
        <h1 className="text-xl font-semibold tracking-tight">{label} — у наступній фазі</h1>
        <p className="text-sm text-muted-foreground">
          Цю сторінку буде побудовано у F1+. Сьогодні працюйте з Головною, а для решти дій —{" "}
          <a className="text-primary hover:underline" href="https://crmold.kormaxtrade.com.ua/" target="_blank" rel="noreferrer">
            Espo-адмінка
          </a>
          .
        </p>
        <div className="flex justify-center gap-2 pt-2">
          <Button onClick={() => navigate("/today")}>На головну</Button>
        </div>
      </div>
    </div>
  );
}
